var React = require('react');

function MailOutline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.2 0.799988H1.80003H0.0090332V15.2H1.80003H16.2H18V0.799988H16.2ZM1.80003 4.39999L9.00003 8.89999L16.2 4.39999V13.4H1.80003V4.39999ZM1.80003 2.59999L9.00003 7.09999L16.2 2.59999H1.80003Z","fill":"#477FB5"}));
}

MailOutline.defaultProps = {"width":"18","height":"16","viewBox":"0 0 18 16","fill":"none"};

module.exports = MailOutline;

MailOutline.default = MailOutline;
